import { Chip, Paper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { isArray, isString } from "lodash";
import toastError from "../../errors/toastError";
import api from "../../services/api";

export function TagsContainer({ contact, ticket, kanban }) {

    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);
    
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        if (isMounted.current) {
            loadTags().then(() => {
                let loadedSelecteds  = []
                if (ticket && Array.isArray(ticket?.tags)) {
                    const ticketTags = ticket?.tags.map((tag) => {
                        return { 
                                id: tag.id, 
                                name: tag.name, 
                                color: tag.color ,
                                companyId: tag.companyId,
                                kanban: tag.kanban,
                            }
                    });
                    loadedSelecteds  = [...loadedSelecteds ,...ticketTags]                
                } 
                if (Array.isArray(contact?.tags)) {
                    const contactTags = contact?.tags.map((tag) => {
                        return { 
                                id: tag.id, 
                                name: tag.name, 
                                color: tag.color ,
                                companyId: tag.companyId,
                                kanban: tag.kanban,
                            }
                    });
                    loadedSelecteds  = [...loadedSelecteds ,...contactTags]
                } 
                setSelecteds(loadedSelecteds || []);
            });
        }
    }, [contact, ticket]);

    const createTag = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const loadTags = async () => {
        try {            
            const { data } = await api.get(`/tags/list`, {
                params:{
                    kanban
                }
            });
                                    
            if(ticket || contact){
                const tempTickets  = data.map((tag) => {
                    return { 
                        id: tag.id, 
                        name: tag.name, 
                        color: tag.color ,
                        companyId: tag.companyId,
                        kanban: tag.kanban,
                    }
                });
                setTags(tempTickets);
            }else{
                setTags(data);
            }   
        } catch (err) {
            toastError(err);
        }
    }

    const syncTags = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags/sync`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const onChange = async (value, reason) => {
        let optionsChanged = []
        if (reason === 'create-option') {
            if (isArray(value)) {
                for (let item of value) {
                    if (item.length < 3) {
                        toastError("Tag muito curta!");
                        return;
                    }
                    if (isString(item)) {
                        const newTag = await createTag({ name: item, kanban: 0, color: getRandomHexColor() })
                        optionsChanged.push(newTag);
                    } else {
                        optionsChanged.push(item);
                    }
                }
            }
            await loadTags();
        } else {
            optionsChanged = value;
        }
        setSelecteds(optionsChanged);
        await syncTags({ contactId: contact?.id,ticketId: ticket?.id , tags: optionsChanged });
    }

    function getRandomHexColor() {
        // Gerar valores aleatórios para os componentes de cor
        const red = Math.floor(Math.random() * 256); // Valor entre 0 e 255
        const green = Math.floor(Math.random() * 256); // Valor entre 0 e 255
        const blue = Math.floor(Math.random() * 256); // Valor entre 0 e 255
      
        // Converter os componentes de cor em uma cor hexadecimal
        const hexColor = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
      
        return hexColor;
    }

    
    return (
        <Paper style={{ padding: 2 }}>
            <Autocomplete
                multiple
                size="small"
                options={tags}
                value={selecteds}                
                onChange={(e, v, r) => onChange(v, r)}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) => option.id === value.id}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            key={index}
                            variant="outlined"
                            style={{
                                backgroundColor: option.color || '#eee',
                                color: "#FFF",
                                marginRight: 1,
                                padding: 1,
                                fontWeight: 'bold',
                                paddingLeft: 5,
                                paddingRight: 5,
                                borderRadius: 3,
                                fontSize: "0.8em",
                                whiteSpace: "nowrap"
                            }}
                            label={option.name}
                            {...getTagProps({ index })}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder="Tag" />
                )}
                PaperComponent={({ children }) => (
                    <Paper
                        style={{ width: 400, marginLeft: 6 }}
                    >
                        {children}
                    </Paper>
                )}
            />
        </Paper>
    )
}